// =====================================================================
// EL MOTIVO DE UN BOTÓN DESHABILITADO, A LA VISTA · Doctrina 2, regla 8
// =====================================================================
// «Botones deshabilitados con la explicación visible de por qué.» Un
// `title` no cuenta: en un teléfono no hay dónde pasar el ratón. Esto
// pinta una línea corta debajo o al lado del botón, y la enlaza con
// `aria-describedby` para quien lee con lector de pantalla.
//
//   <button disabled={!listo} aria-describedby="motivo-crear">Crear</button>
//   <Motivo id="motivo-crear" cuando={!listo}>Falta el SKU y el nombre.</Motivo>
//
// Medido el 19 de septiembre de 2026 con la auditoría de botones: 14
// botones deshabilitados sin decir por qué, en 11 pantallas.
export default function Motivo({ id, cuando = true, children, className = '' }) {
  if (!cuando || !children) return null;
  return (
    <p id={id} role="note" className={`text-xs text-gray-500 ${className}`}>
      {children}
    </p>
  );
}
